import {ImageUploadImageSetModel} from './image-models/image-upload-image-set.model';
import {Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as force from '../force';
import {ProductCategoryService} from '../product-category/services/product-category.service';
import {Guid} from 'guid-typescript';


@Component({
  selector: 'app-product-image-upload',
  templateUrl: './product-image-upload.component.html',
  styleUrls: ['./product-image-upload.component.css']
})
export class ProductImageUploadComponent implements OnInit {
  isUserAuthenticated = false;
  isCorrectRole = false;
  doesModelNumberExist = false;
  identifier: string;
  isProductModel: boolean;
  imageSets: ImageUploadImageSetModel[] = [];
  selectedImageSet: ImageUploadImageSetModel;
  form: FormGroup;
  deleteform: FormGroup;
  loading = false;
  highresimagename = '';
  desklargeimagename = '';
  desksmallimagename = '';
  tabletimagename = '';
  phoneimagename = '';
  isadd = false;
  isedit = false;
  isdelete = false;
  @ViewChild('desklargefile') desklargefile: ElementRef;
  @ViewChild('highresimage') highresimage: ElementRef;
  @ViewChild('desksmallfile') desksmallfile: ElementRef;
  @ViewChild('tabletfile') tabletfile: ElementRef;
  @ViewChild('phonefile') phonefile: ElementRef;
  @ViewChild('openmodal') openmodal: ElementRef;
  @ViewChild('closemodal') closemodal: ElementRef;
  @ViewChild('opendeletemodal') opendeletemodal: ElementRef;
  @ViewChild('closedeletemodal') closedeletemodal: ElementRef;


  constructor(private service: ProductCategoryService, private hostElement: ElementRef, private fb: FormBuilder, private cdRef: ChangeDetectorRef) {
    setTimeout(() => {
      if (!window.location.href.includes('access_token')) {
        if (!this.isUserAuthenticated) {
          force.createOauthCallbackURL('image-upload');
          const params: any[] = [];
          params.push(this.getParameterByName('modelId', window.location.href));
          params.push(this.getParameterByName('ismodel', window.location.href));
          force.login(JSON.stringify(params));
        }
      }
    }, 3000);

  }

  async ngOnInit() {
    force.reloadAccess();
    const state = JSON.parse(force.decodeStateParams());
    this.identifier = state[0];
    this.isProductModel = state[1] === 'true' ? true : false;
    this.doesobjectexist(this.identifier, this.isProductModel);
    this.isUserAuthenticated = force.isAuthenticated();
    this.isRoleAcceptable();

    this.getImages(this.identifier, this.isProductModel);
    this.createForm();
    this.listeners();
  }

  async isRoleAcceptable() {
    this.isCorrectRole = true;
    force.query('select PermissionSet.Label, Assignee.Id from PermissionSetAssignment').then(result => {
      const records: any[] = (<any>result).records;
      records.forEach(r => {
        if (r.Assignee.Id === String(force.getUserId())) {
          if (r.PermissionSet.Label === 'API Access') {
            this.isCorrectRole = true;
          }
        }
      });
    });
  }

  onHighResFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.get('highresimage').setValue({
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        });
        this.highresimagename = file.name;
      };
    }
  }

  onDeskLargeFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.get('desktoplargeimage').setValue({
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        });
        this.desklargeimagename = file.name;
      };
    }
  }

  onDeskSmallFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.get('desktopsmallimage').setValue({
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        });
        this.desksmallimagename = file.name;
      };
    }
  }

  onTabletFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.get('tabletimage').setValue({
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        });
        this.tabletimagename = file.name;
      };
    }
  }

  onPhoneFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.get('phoneimage').setValue({
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        });
        this.phoneimagename = file.name;
      };
    }
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  createForm() {
    this.form = this.fb.group({
      imagecaption: ['', null],
      highresimage: [null, Validators.required],
      desklargeresize: [true, Validators.required],
      desktoplargeimage: null,
      desksmallresize: [true, Validators.required],
      desktopsmallimage: null,
      tabletresize: [true, Validators.required],
      tabletimage: null,
      phoneresize: [true, Validators.required],
      phoneimage: null,
      identifier: null,
      isproductmodel: null,
      id: null,
      line: [true, Validators.required],
      class: [true, Validators.required]
    });
    this.form.get('identifier').setValue(this.identifier);
    this.form.get('isproductmodel').setValue(this.isProductModel);

  }

  createDeleteForm() {
    this.deleteform = this.fb.group({
      imagecaption: null,
      highresimage: null,
      desklargeresize: null,
      desktoplargeimage: null,
      desksmallresize: null,
      desktopsmallimage: null,
      tabletresize: null,
      tabletimage: null,
      phoneresize: null,
      phoneimage: null,
      identifier: null,
      isproductmodel: null,
      id: null,
      line: null,
      class: null
    });
    this.form.get('identifier').setValue(this.identifier);
    this.form.get('isproductmodel').setValue(this.isProductModel);

  }

  setDeleteFormValues(imageSetId: string) {
    if (imageSetId) {
      this.selectedImageSet = this.imageSets.find(x => x.id === imageSetId);
      if (this.selectedImageSet) {
        this.deleteform.setValue({
          imagecaption: this.selectedImageSet.captionName,
          highresimage: {
            filename: this.selectedImageSet.highresimage.name,
            filetype: this.selectedImageSet.highresimage.filetype,
            value: this.selectedImageSet.highresimage.imagedata
          },
          desklargeresize: this.selectedImageSet.desktoplargeimage && this.selectedImageSet.desktoplargeimage.resized ? this.selectedImageSet.desktoplargeimage.resized : false,
          desktoplargeimage: {
            filename: this.selectedImageSet.desktoplargeimage ? this.selectedImageSet.desktoplargeimage.name : {},
            filetype: this.selectedImageSet.desktoplargeimage ? this.selectedImageSet.desktoplargeimage.filetype : {},
            value: this.selectedImageSet.desktoplargeimage ? this.selectedImageSet.desktoplargeimage.imagedata : {}
          },
          desksmallresize: this.selectedImageSet.desktopsmallimage && this.selectedImageSet.desktopsmallimage.resized ? this.selectedImageSet.desktopsmallimage.resized : false,
          desktopsmallimage: {
            filename: this.selectedImageSet.desktopsmallimage ? this.selectedImageSet.desktopsmallimage.name : {},
            filetype: this.selectedImageSet.desktopsmallimage ? this.selectedImageSet.desktopsmallimage.filetype : {},
            value: this.selectedImageSet.desktopsmallimage ? this.selectedImageSet.desktopsmallimage.imagedata : {}
          },
          tabletresize: this.selectedImageSet.tabletimage && this.selectedImageSet.tabletimage.resized ? this.selectedImageSet.tabletimage.resized : false,
          tabletimage: {
            filename: this.selectedImageSet.tabletimage ? this.selectedImageSet.tabletimage.name : {},
            filetype: this.selectedImageSet.tabletimage ? this.selectedImageSet.tabletimage.filetype : {},
            value: this.selectedImageSet.tabletimage ? this.selectedImageSet.tabletimage.imagedata : {}
          },
          phoneresize: this.selectedImageSet.tabletimage && this.selectedImageSet.phoneimage.resized ? this.selectedImageSet.phoneimage.resized : false,
          phoneimage: {
            filename: this.selectedImageSet.tabletimage ? this.selectedImageSet.phoneimage.name : {},
            filetype: this.selectedImageSet.tabletimage ? this.selectedImageSet.phoneimage.filetype : {},
            value: this.selectedImageSet.tabletimage ? this.selectedImageSet.phoneimage.imagedata : {}
          },
          identifier: this.identifier,
          id: this.selectedImageSet.id,
          line: this.selectedImageSet.line,
          class: this.selectedImageSet.class,
          isproductmodel: this.isProductModel
        });
      }
    }
  }

  opendeleteconfirmation(imageSetId: string) {
    this.createDeleteForm();
    this.setDeleteFormValues(imageSetId);
    this.opendeletemodal.nativeElement.click();
  }

  async doesobjectexist(modelnumber: string, isproductmodel: boolean) {
    if (isproductmodel) {
      await this.service.getModelById(modelnumber)
        .then(
          res => {
            if (res) {
              this.doesModelNumberExist = true;
            } else {
              this.doesModelNumberExist = false;
            }
          }
        ).catch(err => console.log(err));
    } else {
      await this.service.getProductById(modelnumber)
        .then(
          res => {
            if (res) {
              this.doesModelNumberExist = true;
            } else {
              this.doesModelNumberExist = false;
            }
          }
        ).catch(err => console.log(err));
    }
  }

  deleteimageset() {
    if (this.deleteform) {
      this.loading = true;
      this.service.deleteImageSet(this.deleteform.value)
        .subscribe(
          (res) => {
            setTimeout(() => {
              this.getImagesrealtime(this.identifier, this.isProductModel);
              this.closedeletemodal.nativeElement.click();
              this.form.reset();
            }, 3000);
          },
          err => console.log(err)
        );
    }
  }

  addNew() {
    this.isadd = true;
    this.isedit = false;
    // this.form.reset();
    this.createForm();
    this.form.get('desklargeresize').setValue(true);
    this.form.get('desksmallresize').setValue(true);
    this.form.get('tabletresize').setValue(true);
    this.form.get('phoneresize').setValue(true);
    this.form.get('highresimage').setValue(null);
    this.form.get('id').setValue(Guid.create().toString());
    this.highresimagename = '';
    this.desklargeimagename = '';
    this.desksmallimagename = '';
    this.tabletimagename = '';
    this.phoneimagename = '';
    this.form.get('line').setValue('Both');
    this.form.get('class').setValue('All');
    if (this.highresimage != null && this.highresimage !== undefined) {
      this.highresimage.nativeElement.value = '';
    }
    if (this.desklargefile != null && this.desklargefile !== undefined) {
      this.desklargefile.nativeElement.value = '';
    }
    if (this.desksmallfile != null && this.desksmallfile !== undefined) {
      this.desksmallfile.nativeElement.value = '';
    }
    if (this.tabletfile != null && this.tabletfile !== undefined) {
      this.tabletfile.nativeElement.value = '';
    }
    if (this.phonefile != null && this.phonefile !== undefined) {
      this.phonefile.nativeElement.value = '';
    }
    this.openmodal.nativeElement.click();
  }

  editForm(imageSetId: string) {
    this.isadd = false;
    this.isedit = true;
    this.setFormValues(imageSetId);
    this.openmodal.nativeElement.click();
  }

  isloading() {
    return this.loading;
  }

  listeners() {
    this.form.get('desklargeresize').valueChanges.distinctUntilChanged().subscribe((value: boolean) => {
      if (value === true) {
        this.form.get('desklargeresize').setValidators([Validators.required]);
        this.form.get('desklargeresize').updateValueAndValidity();
        this.form.get('desktoplargeimage').setValidators(null);
        this.form.get('desktoplargeimage').updateValueAndValidity();
      } else {
        this.form.get('desktoplargeimage').setValidators([Validators.required]);
        this.form.get('desktoplargeimage').updateValueAndValidity();
        this.form.get('desklargeresize').setValidators(null);
        this.form.get('desklargeresize').updateValueAndValidity();
      }
    });

    this.form.get('desksmallresize').valueChanges.distinctUntilChanged().subscribe((value: boolean) => {
      if (value === true) {
        this.form.get('desksmallresize').setValidators([Validators.required]);
        this.form.get('desksmallresize').updateValueAndValidity();
        this.form.get('desktopsmallimage').setValidators(null);
        this.form.get('desktopsmallimage').updateValueAndValidity();
      } else {
        this.form.get('desktopsmallimage').setValidators([Validators.required]);
        this.form.get('desktopsmallimage').updateValueAndValidity();
        this.form.get('desksmallresize').setValidators(null);
        this.form.get('desksmallresize').updateValueAndValidity();
      }
    });

    this.form.get('tabletresize').valueChanges.distinctUntilChanged().subscribe((value: boolean) => {
      if (value === true) {
        this.form.get('tabletresize').setValidators([Validators.required]);
        this.form.get('tabletresize').updateValueAndValidity();
        this.form.get('tabletimage').setValidators(null);
        this.form.get('tabletimage').updateValueAndValidity();
      } else {
        this.form.get('tabletimage').setValidators([Validators.required]);
        this.form.get('tabletimage').updateValueAndValidity();
        this.form.get('tabletresize').setValidators(null);
        this.form.get('tabletresize').updateValueAndValidity();
      }
    });

    this.form.get('phoneresize').valueChanges.distinctUntilChanged().subscribe((value: boolean) => {
      if (value === true) {
        this.form.get('phoneresize').setValidators([Validators.required]);
        this.form.get('phoneresize').updateValueAndValidity();
        this.form.get('phoneimage').setValidators(null);
        this.form.get('phoneimage').updateValueAndValidity();
      } else {
        this.form.get('phoneimage').setValidators([Validators.required]);
        this.form.get('phoneimage').updateValueAndValidity();
        this.form.get('phoneresize').setValidators(null);
        this.form.get('phoneresize').updateValueAndValidity();
      }
    });
  }

  setFormValues(imageSetId: string) {
    if (imageSetId) {
      this.selectedImageSet = this.imageSets.find(x => x.id === imageSetId);
      if (this.selectedImageSet) {
        this.form.setValue({
          imagecaption: this.selectedImageSet.captionName,
          highresimage: {
            filename: this.selectedImageSet.highresimage.name,
            filetype: this.selectedImageSet.highresimage.filetype,
            value: this.selectedImageSet.highresimage.imagedata
          },
          desklargeresize: this.selectedImageSet.desktoplargeimage && this.selectedImageSet.desktoplargeimage.resized ? this.selectedImageSet.desktoplargeimage.resized : true,
          desktoplargeimage: {
            filename: this.selectedImageSet.desktoplargeimage.name,
            filetype: this.selectedImageSet.desktoplargeimage.filetype,
            value: this.selectedImageSet.desktoplargeimage.imagedata
          },
          desksmallresize: this.selectedImageSet.desktopsmallimage && this.selectedImageSet.desktopsmallimage.resized ? this.selectedImageSet.desktopsmallimage.resized : true,
          desktopsmallimage: {
            filename: this.selectedImageSet.desktopsmallimage.name,
            filetype: this.selectedImageSet.desktopsmallimage.filetype,
            value: this.selectedImageSet.desktopsmallimage.imagedata
          },
          tabletresize: this.selectedImageSet.tabletimage && this.selectedImageSet.tabletimage.resized ? this.selectedImageSet.tabletimage.resized : true,
          tabletimage: {
            filename: this.selectedImageSet.tabletimage.name,
            filetype: this.selectedImageSet.tabletimage.filetype,
            value: this.selectedImageSet.tabletimage.imagedata
          },
          phoneresize: this.selectedImageSet.phoneimage && this.selectedImageSet.phoneimage.resized ? this.selectedImageSet.phoneimage.resized : true,
          phoneimage: {
            filename: this.selectedImageSet.phoneimage.name,
            filetype: this.selectedImageSet.phoneimage.filetype,
            value: this.selectedImageSet.phoneimage.imagedata
          },
          identifier: this.identifier,
          id: this.selectedImageSet.id,
          line: this.selectedImageSet.line,
          class: this.selectedImageSet.class,
          isproductmodel: this.isProductModel
        });
        this.highresimagename = this.selectedImageSet.highresimage.name;
        this.desklargeimagename = this.selectedImageSet.desktoplargeimage.name;
        this.desksmallimagename = this.selectedImageSet.desktopsmallimage.name;
        this.tabletimagename = this.selectedImageSet.tabletimage.name;
        this.phoneimagename = this.selectedImageSet.phoneimage.name;
      }
    }
  }

  onSubmit() {
    // this.form.controls["identifier"].setValue(this.identifier);

    const formModel = this.form.value;
    this.loading = true;
    this.service.saveImageSet(formModel)
      .subscribe(
        (res) => {
          setTimeout(() => {
            this.getImagesrealtime(this.identifier, this.isProductModel);
            this.form.reset();
            this.closemodal.nativeElement.click();
          }, 3000);
        },
        err => console.log(err)
      );
  }

  getImagesrealtime(modelnumber: string, isproductmodel: boolean) {
    this.service.getImagesrealtime(modelnumber, isproductmodel)
      .subscribe(
        res => {
          let imageSets: any[];
          imageSets = res as any[];
		  imageSets = imageSets.map(item => item.imageCaption='');
          this.imageSets = imageSets ? imageSets.map(item => new ImageUploadImageSetModel(item)) : [];
          this.form.reset();
          this.createForm();
          this.form.get('desklargeresize').setValue(true);
          this.form.get('desksmallresize').setValue(true);
          this.form.get('tabletresize').setValue(true);
          this.form.get('phoneresize').setValue(true);
          this.form.get('line').setValue('Both');
          this.form.get('class').setValue('All');
          this.highresimagename = '';
          this.desklargeimagename = '';
          this.desksmallimagename = '';
          this.tabletimagename = '';
          this.phoneimagename = '';
          this.loading = false;
          this.cdRef.detectChanges();
        },
        err => console.log(err)
      );
  }


  async getImages(modelnumber: string, isproductmodel: boolean) {

    await this.service.getImages(modelnumber, isproductmodel)
      .then(
        res => {
          if (res) {
            let loadedImageSets: any[];
            loadedImageSets = res as any[];
            this.imageSets = loadedImageSets ? loadedImageSets.map(item => new ImageUploadImageSetModel(item)) : [];
          }
        }
      ).catch(err => console.log(err));

    // // replace all of this later with pulling from S3
    // let testImageSet = new ImageUploadImageSetModel();
    // testImageSet.captionName = 'Indoor Unit';
    // testImageSet.modelNumber = modelnumber;

    // testImageSet.desktoplargeimage = new ImageUploadImageModel();
    // testImageSet.desktoplargeimage.url = "http://via.placeholder.com/400x400";
    // testImageSet.desktoplargeimage.filetype = ".png";
    // testImageSet.desktoplargeimage.name = "large image";
    // testImageSet.desktoplargeimage.resized = true;
    // testImageSet.desktoplargeimage.resolution = "300 X 300";

    // testImageSet.desktopsmallimage = new ImageUploadImageModel();
    // testImageSet.desktopsmallimage.url = "http://via.placeholder.com/400x400";
    // testImageSet.desktopsmallimage.filetype = ".png";
    // testImageSet.desktopsmallimage.name = "small image";
    // testImageSet.desktopsmallimage.resized = true;
    // testImageSet.desktopsmallimage.resolution = "300 X 300";

    // testImageSet.highresimage = new ImageUploadImageModel();
    // testImageSet.highresimage.url = "http://via.placeholder.com/800x800";
    // testImageSet.highresimage.filetype = ".png";
    // testImageSet.highresimage.name = "hi res image";
    // testImageSet.highresimage.resized = true;
    // testImageSet.highresimage.resolution = "300 X 300";

    // testImageSet.tabletimage = new ImageUploadImageModel();
    // testImageSet.tabletimage.url = "http://via.placeholder.com/300x300";
    // testImageSet.tabletimage.filetype = ".png";
    // testImageSet.tabletimage.name = "tablet image";
    // testImageSet.tabletimage.resized = true;
    // testImageSet.tabletimage.resolution = "300 X 300";

    // testImageSet.phoneimage = new ImageUploadImageModel();
    // testImageSet.phoneimage.url = "http://via.placeholder.com/300x300";
    // testImageSet.phoneimage.filetype = ".png";
    // testImageSet.phoneimage.name = "phone image";
    // testImageSet.phoneimage.resized = true;
    // testImageSet.phoneimage.resolution = "300 X 300";

    // this.imageSets.push(testImageSet);
  }


}



// WEBPACK FOOTER //
// ./src/app/image-admin/product-image-upload.component.ts